import { Text } from '@chakra-ui/react';
import React from 'react';
export const ChipLabel = ({ children, ...rest }) => (React.createElement(Text, { variant: "dk-800-rg-4", ...rest }, children));
